import { TOTP } from 'otpauth';

// Mã bí mật cố định cho demo - trong thực tế nên tạo ngẫu nhiên cho mỗi user
const DEMO_SECRET = 'JBSWY3DPEHPK3PXP'; // Base32 encoded secret

// Tạo TOTP instance
export const createTOTP = () => {
  return new TOTP({
    issuer: 'VMON Cloud',
    label: 'Admin Account',
    algorithm: 'SHA1',
    digits: 6,
    period: 30,
    secret: DEMO_SECRET,
  });
};

// Xác thực mã OTP
export const verifyTOTP = (token: string): boolean => {
  const totp = createTOTP();
  
  // Kiểm tra mã hiện tại và mã trước đó (để tránh lỗi đồng bộ thời gian)
  const currentToken = totp.generate();
  const previousToken = totp.generate({ timestamp: Date.now() - 30000 });
  
  return token === currentToken || token === previousToken;
};

// Lấy QR code URI để hiển thị trong Google Authenticator
export const getQRCodeURI = (): string => {
  const totp = createTOTP();
  return totp.toString();
};

// Lấy mã bí mật để nhập thủ công
export const getManualEntrySecret = (): string => {
  return DEMO_SECRET;
};

// Lưu trạng thái 2FA đã được thiết lập
export const set2FAEnabled = (enabled: boolean) => {
  localStorage.setItem('vmon_2fa_enabled', enabled.toString());
};

// Kiểm tra 2FA đã được thiết lập chưa
export const is2FAEnabled = (): boolean => {
  return localStorage.getItem('vmon_2fa_enabled') === 'true';
};

// Lưu trạng thái đã xác thực 2FA trong phiên hiện tại
export const set2FAVerified = (verified: boolean) => {
  sessionStorage.setItem('vmon_2fa_verified', verified.toString());
};

// Kiểm tra đã xác thực 2FA trong phiên hiện tại chưa
export const is2FAVerified = (): boolean => {
  return sessionStorage.getItem('vmon_2fa_verified') === 'true';
};

// Xóa trạng thái xác thực 2FA
export const clear2FAVerification = () => {
  sessionStorage.removeItem('vmon_2fa_verified');
};